(function() {
  var styleId = 'mp-filters-custom-scrollbar-styles';
  var scrollbarClass = 'custom-scrollbar-active';

  function addStyles() {
    if (document.getElementById(styleId)) return;
    var s = document.createElement('style');
    s.id = styleId;
    s.textContent = [
      '.top_bar_filter_inner_section.' + scrollbarClass + '{ scrollbar-width: none; -ms-overflow-style: none; }',
      '.top_bar_filter_inner_section.' + scrollbarClass + '::-webkit-scrollbar { height: 0 !important; display: none !important; }',
      '.top_bar_filter_custom_scroll { padding: 5px; background: #fff; width: 100%; box-sizing: border-box; }',
      '.top_bar_filter_scroll_wrapper { display: flex !important; flex-direction: column !important; width: 100% !important; }',
      '.top_bar_filter_custom_scroll_track { height: 6px; background: #fff; border-radius: 10px; position: relative; cursor: pointer; overflow: hidden; -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.08); box-shadow: inset 0 0 6px rgba(0,0,0,.08); margin: 0 auto; }',
      '.top_bar_filter_custom_scroll_thumb { height: 100%; min-width: 40px; border-radius: 10px; background: #babac0; position: absolute; left: 0; top: 0; cursor: grab; pointer-events: auto; transition: background .15s; }',
      '.top_bar_filter_custom_scroll_thumb:hover { background: #858585; }',
      '.top_bar_filter_custom_scroll_thumb:active { cursor: grabbing; }'
    ].join('\n');
    document.head.appendChild(s);
  }

  function init(el) {
    if (el.dataset.customScrollbar === 'true') return;
    el.dataset.customScrollbar = 'true';
    el.classList.add(scrollbarClass);

    var wrap = document.createElement('div');
    wrap.className = 'top_bar_filter_custom_scroll';
    wrap.setAttribute('aria-hidden', 'true');

    var track = document.createElement('div');
    track.className = 'top_bar_filter_custom_scroll_track';

    var thumb = document.createElement('div');
    thumb.className = 'top_bar_filter_custom_scroll_thumb';

    track.appendChild(thumb);
    wrap.appendChild(track);

    var parent = el.parentNode;
    var wrapper = document.createElement('div');
    wrapper.className = 'top_bar_filter_scroll_wrapper';
    parent.insertBefore(wrapper, el);
    wrapper.appendChild(el);
    wrapper.appendChild(wrap);

    function updateThumb() {
      var sw = el.scrollWidth;
      var cw = el.clientWidth;
      var maxScroll = sw - cw;
      if (maxScroll <= 0) {
        wrap.style.display = 'none';
        return;
      }
      wrap.style.display = '';
      wrap.style.width = '100%';
      track.style.width = cw + 'px';
      var trackW = cw;
      var thumbW = Math.max(40, (cw / sw) * trackW);
      var thumbLeft = (el.scrollLeft / maxScroll) * (trackW - thumbW);
      thumb.style.width = thumbW + 'px';
      thumb.style.transform = 'translateX(' + thumbLeft + 'px)';
    }

    el.addEventListener('scroll', updateThumb);
    window.addEventListener('resize', updateThumb);
    updateThumb();

    track.addEventListener('click', function(e) {
      if (e.target === thumb) return;
      var trackRect = track.getBoundingClientRect();
      var maxScroll = el.scrollWidth - el.clientWidth;
      if (maxScroll <= 0) return;
      var x = e.clientX - trackRect.left;
      var trackW = trackRect.width;
      var thumbW = thumb.offsetWidth;
      var range = trackW - thumbW;
      if (range <= 0) return;
      var pct = Math.max(0, Math.min(1, (x - thumbW / 2) / range));
      el.scrollLeft = pct * maxScroll;
    });

    var dragging = false;
    var startX, startScrollLeft;

    thumb.addEventListener('mousedown', function(e) {
      e.preventDefault();
      dragging = true;
      startX = e.clientX;
      startScrollLeft = el.scrollLeft;
    });

    document.addEventListener('mousemove', function(e) {
      if (!dragging) return;
      var maxScroll = el.scrollWidth - el.clientWidth;
      if (maxScroll <= 0) return;
      var trackW = track.getBoundingClientRect().width;
      var thumbW = thumb.offsetWidth;
      var range = trackW - thumbW;
      if (range <= 0) return;
      var dx = e.clientX - startX;
      var scrollDelta = (dx / range) * maxScroll;
      el.scrollLeft = Math.max(0, Math.min(maxScroll, startScrollLeft + scrollDelta));
    });

    document.addEventListener('mouseup', function() {
      dragging = false;
    });

    thumb.addEventListener('touchstart', function(e) {
      dragging = true;
      startX = e.touches[0].clientX;
      startScrollLeft = el.scrollLeft;
    }, { passive: true });

    document.addEventListener('touchmove', function(e) {
      if (!dragging) return;
      var maxScroll = el.scrollWidth - el.clientWidth;
      if (maxScroll <= 0) return;
      var trackW = track.getBoundingClientRect().width;
      var thumbW = thumb.offsetWidth;
      var range = trackW - thumbW;
      if (range <= 0) return;
      var dx = e.touches[0].clientX - startX;
      var scrollDelta = (dx / range) * maxScroll;
      el.scrollLeft = Math.max(0, Math.min(maxScroll, startScrollLeft + scrollDelta));
      startX = e.touches[0].clientX;
      startScrollLeft = el.scrollLeft;
    }, { passive: true });

    document.addEventListener('touchend', function() {
      dragging = false;
    });
  }

  function run() {
    addStyles();
    document.querySelectorAll('.top_bar_filter_inner_section').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);
})();
